export const bodyTextLimit = 1024;
export const bodyTextLimit160 = 160;

// filter all variables
const variableRegEx = /{{([^}]*)}}/g;

const checkCurlyBrackets = /{{2}([^{}]+){2}(?=\}{2})/g;

// filter only custom variables
const customVariablesRegEx = /{{(custom-variable\d+)}}/g;

// Match any valid hyphenated variable (lowercase letters, numbers, hyphens)
// This includes profile attributes like {{first-name}}, {{annual-income}}, {{preferred-location-1}}
const validVariableRegEx = /^{{[a-z0-9][a-z0-9-]*}}$/;

// validation patterns
const variableValidationPattern = [
  // /}}{{/g,
  /{{2}[^}]*[^}]}[^}]/g,
  /(.*?){{(.*?)}}}(.*?)/g,
  /(.*?){{{(.*?)}}(.*?)/g,
];

export const checkVariable = (value) =>
  value?.toString()?.toLowerCase()?.match(variableRegEx);

export const fliterWithCurlyBrackets = (value) =>
  value?.toString()?.toLowerCase()?.match(checkCurlyBrackets);

export function checkVariableExist(value) {
  // Extract all variables from text and return them if they match valid format
  const matches = value?.toString()?.match(variableRegEx) || [];
  return matches.filter(match => match.match(validVariableRegEx));
}

export function checkVariables(value, variable) {
  if (variable !== '{{custom-variable')
    return value?.toString()?.includes(variable);

  return false;
}

// Only allows custom variables ({{custom-variable1}}, {{custom-variable2}}, etc.)
// Profile attributes are validated separately through the existing variables list
export const checkIsoriginalVariable = (variable) => {
  // Only accept custom-variable pattern for manually typed variables
  if (variable?.toString()?.match(customVariablesRegEx)) {
    return true;
  }
  return false;
};

export const updateVariablesOrder = (value, variables) => {
  let result = fliterWithCurlyBrackets(value);
  let list = [];

  result?.map((r, i) => {
    const formatedVariable = `${r}}}`;
    const data = variables?.filter((v) => v?.title === formatedVariable);
    const existsInVariables = data?.length > 0;
    const isCustomVariable = checkIsoriginalVariable(formatedVariable);

    // Only process if it's a custom variable OR already exists in variables list
    if (isCustomVariable || existsInVariables) {
      const checkList = list?.filter((l) => l?.title === formatedVariable);

      if (existsInVariables && checkList?.length === 0) {
        // Variable already exists - preserve it
        list.push({ ...data?.[0], title: formatedVariable });
      } else if (isCustomVariable && !existsInVariables && checkList?.length === 0) {
        // Only add NEW variables if they match custom-variable pattern
        list.push({
          title: formatedVariable,
          value: variables[i]?.value || variables[i] || '',
        });
      }
    }
  });
  return list;
};

export const replaceWord = (paragraph, replacement) => {
  // Replace all valid variables with the replacement text
  // This handles all variables including profile attributes
  return paragraph?.replaceAll?.(variableRegEx, function (match, variable) {
    const fullMatch = `{{${variable}}}`;
    if (fullMatch.match(validVariableRegEx)) {
      return replacement;
    }
    return match;
  }) || paragraph;
};

export const addClosingBracket = (str) => {
  const regex = /\{+(?!})*$/g;
  return str?.replaceAll(regex, `{{$1}}`);
};

export const getVariableCount = (value) =>
  value?.toString()?.toLowerCase()?.match(variableRegEx);

export const getCustomVariableCount = (value) =>
  value?.toString()?.toLowerCase()?.match(customVariablesRegEx);

export const replaceCustomVariableCount = (value) => {
  var count = 1;
  var updatedStr = value?.replaceAll(
    customVariablesRegEx,
    function (match, variable) {
      return `{{custom-variable${count++}}}`;
    }
  );

  return updatedStr;
};

export const checkVariablesAreValid = (value) => {
  const res = variableValidationPattern?.map((p, i) => {
    var updatedStr = value?.toString().toLowerCase().match(p);
    return updatedStr?.length > 0 ? true : false;
  });
  return res?.filter((r) => r === true)?.length > 0 ? true : false;
};

export const getVariablesCount = (value) => {
  let count = 1;

  // Replace all valid variables with their count
  // This handles all variables including profile attributes
  value = value?.replaceAll?.(variableRegEx, function (match, variable) {
    const fullMatch = `{{${variable}}}`;
    if (fullMatch.match(validVariableRegEx)) {
      return `${count++}`;
    }
    return match;
  });

  return value;
};

export const getReplacedVariablesCount = (value) => {
  let count = 1;

  // Replace all valid variables and return the count
  // This handles all variables including profile attributes
  value?.replaceAll?.(variableRegEx, function (match, variable) {
    const fullMatch = `{{${variable}}}`;
    if (fullMatch.match(validVariableRegEx)) {
      count++;
    }
    return match;
  });

  return count;
};

/**
 * Check for duplicate variables in text
 * @param {string} text - Template text
 * @returns {Array} - Array of duplicate variable names
 */
export const checkDuplicateVariables = (text) => {
  if (!text) return [];
  const matches = text.match(variableRegEx) || [];
  const seen = new Set();
  const duplicates = [];

  matches.forEach((v) => {
    const lowerV = v.toLowerCase();
    if (seen.has(lowerV)) {
      if (!duplicates.includes(lowerV)) {
        duplicates.push(lowerV);
      }
    }
    seen.add(lowerV);
  });

  return duplicates;
};

/**
 * Check if variables are at start or end of text
 * @param {string} text - Template text
 * @returns {Object} - { startsWithVariable: boolean, endsWithVariable: boolean, startVar: string|null, endVar: string|null }
 */
export const checkVariablePosition = (text) => {
  if (!text) return { startsWithVariable: false, endsWithVariable: false };

  const trimmedText = text.trim();
  const result = {
    startsWithVariable: false,
    endsWithVariable: false,
    startVar: null,
    endVar: null,
  };

  // Check if starts with variable
  const startMatch = trimmedText.match(/^{{([a-z0-9][a-z0-9-]*)}}/i);
  if (startMatch) {
    result.startsWithVariable = true;
    result.startVar = startMatch[1];
  }

  // Check if ends with variable
  const endMatch = trimmedText.match(/{{([a-z0-9][a-z0-9-]*)}}$/i);
  if (endMatch) {
    result.endsWithVariable = true;
    result.endVar = endMatch[1];
  }

  return result;
};
